import React from 'react';
import './index.scss';

import { inject, observer } from 'mobx-react';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

import CustomButton from "../../basic/CustomButton";

@inject('internal')
@observer
export default class DeleteDialog extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            loadingBtn: false
        }
    }

    componentWillReceiveProps() {
        this.setState({loadingBtn: false})
    }
    
    handleClose = () => {
        if(this.props.internal.actionDelete) {
            this.props.internal.setActionDelete();
        }
        else{
            this.props.close();
        }
        
    };

    handleDelete = () => {
        this.setState({loadingBtn: true});
        this.props.delete();
    }

    render() {
        return (
            <Dialog
                open={this.props.open}
                onClose={this.handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                >
                <DialogTitle id="alert-dialog-title">{this.props.title}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                    {this.props.content}
                    
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.handleClose} className={'text-gray'}>
                    {this.props.btn_cancel}
                    </Button>
                    <CustomButton
                        progressBar={this.state.loadingBtn}
                        onClick={this.handleDelete}
                        title={this.props.btn_delete}
                        mystyle={'btn-white-bg text-red'}
                        justText
                    />
                    {/* <Button onClick={this.props.delete} className={'text-red'} autoFocus>
                    {this.props.btn_delete}
                    </Button> */}
                </DialogActions>
            </Dialog>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/global/deleteDialog/index.js